import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaceSad = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 31C26.0751 31 31 26.0751 31 20C31 13.9249 26.0751 9 20 9C13.9249 9 9 13.9249 9 20C9 26.0751 13.9249 31 20 31Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5 20C25.3284 20 26 19.3284 26 18.5C26 17.6716 25.3284 17 24.5 17C23.6716 17 23 17.6716 23 18.5C23 19.3284 23.6716 20 24.5 20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 26C17 25.2044 17.3161 24.4413 17.8787 23.8787C18.4413 23.3161 19.2044 23 20 23C20.7956 23 21.5587 23.3161 22.1213 23.8787C22.6839 24.4413 23 25.2044 23 26",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgFaceSad);
export default ForwardRef;
